// frontend/src/askos/RecommendedForYouCard.js
//
// Heuristic recommendations: weakest subjects (by StudentConceptMastery)
// plus matching external references, from GET /tenant/{slug}/askos/recommendations.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecommendations } from '../api/bookmarksApi';

const RESOURCE_ICON = { book: '📘', pdf: '📄', article: '📰', video: '🎬' };

const RecommendedForYouCard = ({ slug }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        getRecommendations(slug)
            .then(setData)
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, [slug]);

    const hasContent = data && (data.weak_subjects?.length > 0 || data.resources?.length > 0);

    return (
        <article className="panel">
            <div className="panel-heading">
                <h3>Recommended for You</h3>
                <a href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/saved-resources'); }}>Saved Resources</a>
            </div>

            {loading && <p className="empty-note">Loading…</p>}
            {!loading && !hasContent && (
                <p className="coming-soon">Attempt a few PYQs or chat questions to get personalized recommendations here.</p>
            )}

            {!loading && data?.weak_subjects?.map(s => (
                <div key={s.project_id} className="recommend-subject-row">
                    <strong>{s.project_name}</strong>
                    <div className="mastery-bar"><div className="mastery-fill" style={{ width: `${Math.min(100, s.avg_mastery)}%` }} /></div>
                    <span>{Math.round(s.avg_mastery)}%</span>
                </div>
            ))}

            {!loading && data?.resources?.map(r => (
                <a key={r.id} className="news-row" href={r.url || '#'} target={r.url ? '_blank' : undefined} rel="noopener noreferrer">
                    <span>{RESOURCE_ICON[r.type] || '📎'}</span>
                    <strong>{r.title}</strong>
                    <small>{r.source_label || r.topic || ''}</small>
                </a>
            ))}
        </article>
    );
};

export default RecommendedForYouCard;
